// src/pages/admin/AdminLogin.js
import React from 'react';
import LoginPage from '../../components/LoginPage';

const AdminLogin = () => {
  return (
    <LoginPage userStr="管理者" userType="admin" pageTitle="管理者ログイン" />
  );
};

export default AdminLogin;